var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkMenu = function SvgExternalLinkMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m15.55 0-5.1.005a.45.45 0 0 0-.45.45v1.041a.45.45 0 0 0 .46.45l2.3-.085.064.065L4.11 10.64a.375.375 0 0 0 0 .532l.719.718a.374.374 0 0 0 .531 0l8.714-8.714.065.064-.085 2.3a.45.45 0 0 0 .45.46h1.04a.45.45 0 0 0 .45-.45L16 .45a.45.45 0 0 0-.45-.45M13.5 9H13a.5.5 0 0 0-.5.5v4.813a.19.19 0 0 1-.187.187H1.688a.19.19 0 0 1-.188-.187V3.688a.187.187 0 0 1 .188-.188H6.5A.5.5 0 0 0 7 3v-.5a.5.5 0 0 0-.5-.5h-5A1.5 1.5 0 0 0 0 3.5v11A1.5 1.5 0 0 0 1.5 16h11a1.5 1.5 0 0 0 1.5-1.5v-5a.5.5 0 0 0-.5-.5"
  })));
};
export default SvgExternalLinkMenu;